import React, { useMemo } from 'react';
import type { RouteOperationalProcessesPayload } from '../../operationalDomain/processes/operationalProcessTypes';
import { buildRouteWorkloadStrip } from '../../operationalDomain/workload/operationalInboxTypes';

import { OPERATIONAL_DEPARTMENT_LABELS } from '../../operationalDomain/operationalLabels';

export type ExecutionWorkloadStripProps = {
  payload: RouteOperationalProcessesPayload | null | undefined;
};

const ExecutionWorkloadStrip: React.FC<ExecutionWorkloadStripProps> = ({ payload }) => {
  const model = useMemo(() => buildRouteWorkloadStrip(payload), [payload]);
  if (!model) return null;

  return (
    <section className="execution-workspace__panel execution-workspace__panel--workload">
      <div className="execution-workspace__panel-title">Внимание</div>
      <ul className="execution-workload-strip">
        {model.criticalCount > 0 ? (
          <li className="execution-workload-strip__item execution-workload-strip__item--critical">
            {model.criticalCount} критических процессов
          </li>
        ) : null}
        {model.highAttentionCount > 0 ? (
          <li className="execution-workload-strip__item">
            {model.highAttentionCount} требуют реакции
          </li>
        ) : null}
        {model.overdueCount > 0 ? (
          <li className="execution-workload-strip__item execution-workload-strip__item--overdue">
            {model.overdueCount} просрочено
          </li>
        ) : null}
        {model.overloadedDepartments.map((d) => (
          <li key={d} className="execution-workload-strip__item execution-workload-strip__item--dept">
            {OPERATIONAL_DEPARTMENT_LABELS[d] ?? d} — повышенная нагрузка
          </li>
        ))}
      </ul>
    </section>
  );
};

export default ExecutionWorkloadStrip;
